// (B) notification 활성 개수 추적 스토어 — KitThemeHost 가 antd notification stack threshold(3) 재현에 사용.
//   count > 3 → Toaster expand=false(겹침, hover 시 펼침) / count <= 3 → expand=true(펼침).
// id 기반 Set 으로 같은 key 갱신의 이중집계·중복삭제를 방지. realm(window)별 모듈 싱글톤이라
// main/popup 각각 독립 카운트(각 realm 의 KitThemeHost 가 구독).
// sonner Toaster 분리용 id — notification(top-right)/result(bottom-center)를 별도 Toaster 로 라우팅해
// hover·collapse·expand 상태를 서로 독립시킨다(toast 옵션 toasterId ↔ <Toaster id>).
// ※ message(top-center)는 sonner 미사용 — 별도 커스텀 host(OmMessageHost/messageStore)가 담당한다.
export const NOTIFICATION_TOASTER_ID = 'om-notification'
// showResult/export 진행상태 등 open() 커스텀 토스트 전용 — notification 의 stack/hover-expand 와 격리.
export const RESULT_TOASTER_ID = 'om-result'

const activeIds = new Set<string>()
const listeners = new Set<() => void>()

function emit(): void {
  listeners.forEach((listener) => listener())
}

export const notificationStack = {
  add(id: string | number | undefined): void {
    if (id == null) return
    const key = String(id)
    if (!activeIds.has(key)) {
      activeIds.add(key)
      emit()
    }
  },
  remove(id: string | number | undefined): void {
    if (id == null) return
    if (activeIds.delete(String(id))) emit()
  },
  clear(): void {
    if (activeIds.size > 0) {
      activeIds.clear()
      emit()
    }
  },
  subscribe(listener: () => void): () => void {
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
    }
  },
  getCount(): number {
    return activeIds.size
  },
}
